import React, { Component } from "react";
import "./Site.css";
import Alert from "react-s-alert";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  UncontrolledCollapse
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, chartHelper, filterHelper } from "../helpers";
import moment from "moment";
import _ from "lodash";
import { ChartEquipmentStatus } from ".";

const getEquipments = () => api.fetch('Equipment/Dashboard').then(response => {
  const {
    upcomingCalibrations,
    overdueCalibrations,
    upcomingMaintenance,
    overdueMaintenance,
    equipmentChartData,
    damages
  } = response.data;
  const shapedData = _.chain(equipmentChartData).map(row => {
    const title = row.type;
    delete row.type;
    const mappedValues =
      _.chain(row)
      .map((value, key) => {
        return {
          label: _.startCase(key),
          value: value
        };
      })
      .value();
    return {title: title, data: chartHelper.getStatusChartData(mappedValues)};
  }).value();
  return {
    upcomingCalibrations: upcomingCalibrations,
    overdueCalibrations: overdueCalibrations,
    upcomingMaintenance: upcomingMaintenance,
    overdueMaintenance: overdueMaintenance,
    equipmentChartData: shapedData,
    totalEquipment: equipmentChartData.length,
    damages
  };
}).catch(x => console.error(x));

export default class EquipmentDashboard extends Component {
  static displayName = EquipmentDashboard.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      filters: [],
      pagedList: null,
      sortColumn: "MaintenanceDate",
      sortAscending: true,
      searchValue: '',
      upcomingCalibrations: [],
      overdueCalibrations: [],
      upcomingMaintenance: [],
      overdueMaintenance: [],
      equipmentChartData: [],
      totalEquipment: null,
      damages: []
    };
    this.downloadReport = this.downloadReport.bind(this);

  }

  componentDidMount() {
    Promise.all([getEquipments()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        // this.loadCalibrationRecord();
      });
    });
  }

  downloadReport() {
    const resolvedFilters = this.state.filters;
    const resolvedSort = {
      sortColumn: this.state.sortColumn,
      sortAscending: this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
    };
    api.postFormDataGetBlob("Equipment/ExportEquipmentDashboardReport", payload)
      .then(response => {
        if (response.status === 200) {
          const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
          const XLSX_FILENAME = `equiptment_report.xlsx`;
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
          }
          else {
            const file = new Blob([response.data], { type: XLSX_MIME });
            var anchor = window.document.createElement('a');
            anchor.download = XLSX_FILENAME;
            anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
            anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
            anchor.click();
          }
        } else {
          throw new Error("Error downloading report");
        }
      }).catch(error => Alert.error(error));
  }

  render() {
    const {
      upcomingCalibrations,
      overdueCalibrations,
      upcomingMaintenance,
      overdueMaintenance,
      equipmentChartData,
      totalEquipment,
      damages
    } = this.state;
    const dashboardList = (list, name, iconType) => {
      const togglerName = `${name}Toggler`;
      const metricName = _.startCase(name);
      const count = list && list.length ? list.length : 0;
      const recordLink = _.includes(togglerName, "calibrations") ? "calibration_record" : "maintenance_record";
      const lotsToDoHere = count > 10;
      const maintenanceState = (item) => {
        const newState = { equipmentId: item.equipmentId, scheduledWorkId: item.scheduledWorkId };
        if (_.includes(togglerName, "damage")) {
          newState.damageId = item.damageId
        }
        return newState;
      };
      return (
        <Col xs="12" md="6">
          <Card className="mb-2">
            <CardHeader id={togglerName} className="softGrayBG">
              <Row className="align-items-center">
                <Col xs="9" className="text-center">
                  <FontAwesomeIcon icon={iconType} className="mr-2 mb-3 d-inline cbdBrightBlue" size="4x" /><br/>
                  <strong className="navyBlue fontSize150"><i>{metricName}</i></strong>
                </Col>
                <Col xs="3">
                  <div className="float-right fontSize350 cbdDarkBlue">
                    <span className={lotsToDoHere ? "text-danger" : ""}>
                      <strong>{count}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <UncontrolledCollapse toggler={togglerName} disabled={count === 0}>
              <CardBody>
                <ListGroup>
                  {list && count > 0 && list.map((item, idx) => (
                    <ListGroupItem key={`${togglerName}${item.equipmentId}${item.calibrationId}${idx}`}>
                      <Link
                        to={`/edit_equipment/${item.equipmentId}`}
                        title={`View/Edit ${item.equipmentName}`}
                        className="float-left"
                      >
                        {item.equipmentName}
                      </Link>
                      <Button
                        tag={Link}
                        // to={`/${recordLink}/${item.equipmentId}`}
                        to={{
                          pathname: `/${recordLink}/new`,
                          state: maintenanceState(item),
                          push: true,
                        }}

                        title={`Complete this task`}
                        size="sm"
                        className="cbdmdPrimaryOutline float-right"
                      >
                        {moment(item.date).format("M/DD/YYYY")}
                      </Button>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </CardBody>
            </UncontrolledCollapse>
          </Card>
        </Col>
      )
    }
    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2 mb-3">
          <Col>
            <h4>Equipment Dashboard</h4>
          </Col>
        </Row>
        <Row>
          <Col xs="8">
            <Row className="align-items-center">
              <Col xs="1" className="equipmentBlue fontSize125 minHeight110">
                <Row className="p-0 m-0 rotate90Text">
                  <Col className="p-0 m-0">
                    <span><strong >UPCOMING</strong></span>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  {dashboardList(upcomingCalibrations, 'calibrations', 'weight')}
                  {dashboardList(upcomingMaintenance, 'maintenance', 'wrench')}
                </Row>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col xs="1" className="equipmentBlue fontSize125 minHeight110">
                <Row className="p-0 m-0 rotate90Text">
                  <Col className="p-0 m-0">
                    <span><strong >OVERDUE</strong></span>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  {dashboardList(overdueCalibrations, 'calibrations', 'balance-scale-right')}
                  {dashboardList(overdueMaintenance, 'maintenance', 'calendar-times')}
                </Row>
              </Col>
            </Row><Row className="align-items-center">
              <Col xs="1" className="equipmentBlue fontSize125 minHeight110">
                <Row className="p-0 m-0 rotate90Text">
                  <Col className="p-0 m-0">
                    <span><strong >DAMAGES</strong></span>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  {dashboardList(damages, 'damages', 'toolbox')}
                </Row>
              </Col>
            </Row>
          </Col>
          <Col>
            {equipmentChartData && 
              <ChartEquipmentStatus
                data={equipmentChartData}
                totalEquipment={totalEquipment}
              />
            }
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentDashboard.js